<ng-container *ngIf="!isLoading; else loader">
    <div class="h-full w-full p-4 content-center text-center font-bold overflow-auto">
    <p class="card-h1 empty-state-text">Companies surged on your intent topics last week!</p>

    <p class="empty-state-text text-base text-muted" *ngIf="topicsPredictiveIntent?.length !== 0"><a class="count-text"
            (click)="navigateToSearch(intentSourceEnum.SALES_INTEL)">{{ surgeCount?.[intentSourceEnum.SALES_INTEL] | intentNumberAbbreviator }}</a>
        companies surged on
        PredictiveIntent topics</p>
    <p class="empty-state-text text-base text-muted" *ngIf="topicsBombora?.length !== 0"><a class="count-text"
            (click)="navigateToSearch(intentSourceEnum.BOMBORA)">{{ surgeCount?.[intentSourceEnum.BOMBORA] | intentNumberAbbreviator }}</a>
        companies surged on Bombora
        topics</p>

    <ng-container *ngIf="isAdmin; else notAdmin">
        <p class="empty-state-text text-base text-muted">Get fresh intent data delivered to your CRM and inbox each week.<br />
            <ng-container *ngIf="featureFlagsEnum.GTMCanvas | isFeatureFlagEnabled | async; else legacyLink">
                <a [routerLink]="resultTabsetUrlsEnum.AGENTIC_WORKFLOWS">Create an Intent Agent</a>
            </ng-container>
            <ng-template #legacyLink>
                View our <a href="https://support.salesintel.io/hc/en-us/articles/33710130303257-Intent-Automations-Setup-Guide" target="_blank">Setup Guide</a> to learn how to create Intent Agents
            </ng-template>
        </p>
    </ng-container>
    <ng-template #notAdmin>
        <p class="empty-state-text text-base text-muted">Get fresh intent data delivered to your CRM and inbox each week.<br /> Ask your
            Admin to
            set up Intent Agents.</p>
        <a matButton="filled" target="_blank"
            href="mailto:{{adminEmail}}?subject=Please set up SalesIntel Intent Agents">Send Email</a>
    </ng-template>
    </div>
</ng-container>
<ng-template #loader>
    <div class="flex justify-center items-center h-full w-full">
        <mat-spinner></mat-spinner>
    </div>
</ng-template>
